import { Component, Input } from '@angular/core';

@Component({
  selector: 'lib-title-bar',
  templateUrl: './title-bar.component.html',
  styleUrls: ['./title-bar.component.css'],
  standalone: true
})
export class TitleBarComponent {
  @Input() title!: string;
  @Input() subtitle?: string | null = null;

  constructor() {}
}
